import { Injectable } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';

@Injectable({
  providedIn: 'root',
})
export class GridLocalizationService {
  constructor() {}

  gridLocalization() {
    const toolbarAddButton: NodeList =
      document.querySelectorAll('e-tbar-btn-text');
    for (let index = 0; index < toolbarAddButton.length; index++) {
      (toolbarAddButton.item(index) as HTMLElement).innerText = 'Ekle';
    }

    const itemsPerPage: NodeList = document.querySelectorAll('.e-constant');
    for (let index = 0; index < itemsPerPage.length; index++) {
      (itemsPerPage.item(index) as HTMLElement).innerText = 'Sayfa Başına';
    }
    const pages: NodeList = document.querySelectorAll('.e-pagenomsg');
    for (let index = 0; index < pages.length; index++) {
      (pages.item(index) as HTMLElement).innerText = (
        pages.item(index) as HTMLElement
      ).innerText.replace('pages', 'sayfa');
      (pages.item(index) as HTMLElement).innerText = (
        pages.item(index) as HTMLElement
      ).innerText.replace('of', '/');
    }
    const pageCount: NodeList = document.querySelectorAll('.e-pagecountmsg');
    for (let index = 0; index < pageCount.length; index++) {
      (pageCount.item(index) as HTMLElement).innerText = (
        pageCount.item(index) as HTMLElement
      ).innerText.replace('items', 'kayıt');
    }

    const pageCounts: NodeList = document.querySelectorAll('.e-pagecountmsg');
    for (let index = 0; index < pageCounts.length; index++) {
      (pageCounts.item(index) as HTMLElement).innerText = (
        pageCounts.item(index) as HTMLElement
      ).innerText.replace('item', 'kayıt');
    }

    const gridGroupText: NodeList = document.querySelectorAll(
      '.e-groupdroparea e-lib e-droppable e-draggable'
    );
    for (let index = 0; index < gridGroupText.length; index++) {
      (gridGroupText.item(index) as HTMLElement).innerText =
        'Yetki Grubu ve Servis Koduna Gore Gruplamak İçin Kolonu Seçin Ve Sürükleyin';
    }
  }
}
